import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDoLoginMutation, useVerifyOTPMutation } from "../Store/api/AuthApi";
import { number, object, string } from "yup";
import { useSelector } from "react-redux";
import axios from "axios";
import Bowser from "bowser"; // A library to parse user agent string
import { publicIp } from "public-ip"; // A library to get public IP address
import { RootState } from "../Store";

let emailSchema = object().shape({
  email: string()
    .email({ email: "Please enter valid email" })
    .required({ email: "Email is required" }),
});

let otpSchema = object().shape({
  email: string()
    .email({ email: "Please enter valid email" })
    .required({ email: "Email is required" }),
  otp: number({ otp: "OTP sholud be a number." }).required({
    otp: "Please enter OTP.",
  }),
});

export default function Login() {
  const isAuth = useSelector((state: RootState) => state.auth.token);
  const [formData, setFormData] = useState({ email: "", otp: "" });
  const [otpInput, setOtpInput] = useState(false);
  const [locData, setLocData] = useState({});
  const [errors, setError] = useState({});
  const [login, { isLoading }] = useDoLoginMutation();
  const [verifyOTP] = useVerifyOTPMutation();

  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (isAuth) {
      navigate("/resume", { replace: true });
    }
  }, [isAuth, navigate]);

  const handleValidationError = useCallback(
    (err) => {
      let errObj = {};
      err.errors.map((msg, i) => {
        let keys = Object.keys(msg);
        if (errObj[keys[0]] === undefined) {
          errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
        }
        return null;
      });
      setError(errObj);
    },
    [setError]
  );

  useEffect(() => {
    //  async function getLocDetail() {
    //    const ipAddress = await publicIp();
    //    return await axios.get(`https://ipapi.co/${ipAddress}/json/`);
    //  }
    //  getLocDetail().then((res) => {
    //    setLocData(res?.data);
    //  });
  }, []);

  const handleLogin = useCallback(
    (res) => {
      login({ email: formData?.email }).then((res) => {
        setOtpInput(true);
      });
    },
    [setOtpInput, formData, login]
  );

  const handleVerifyOTP = useCallback(
    async (res) => {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const browserInfo = browser.getResult();

      const postData = {
        email: formData?.email,
        otp: formData?.otp,
        login_date: new Date(),
        logout_date: null, // will be filled during logout
        //   latitude: locData?.latitude,
        //   longitude: locData?.longitude,
        //   ip_address: locData?.ip,
        //   city: locData?.city,
        //   country: locData?.country_name,
        latitude: "11.11111",
        longitude: "11.1111",
        ip_address: "127.0.0.1",
        city: "Defult city",
        country: "IN",
        browser: browserInfo.browser.name,
        os: browserInfo.os.name,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        created_at: new Date(),
      };
      verifyOTP(postData).then((res) => {
        if (!res.error) {
          if (res.data?.data?.isGuest) {
            navigate("/create-profile", {
              state: { login: true, email: res.data?.data?.email },
            });
          } else if (!res.data?.data?.isGuest) {
            navigate("/resume", { replace: true });
          }
        }
      });
    },
    [formData, verifyOTP, navigate, locData]
  );

  const handleEmailChnage = useCallback(() => {
    setOtpInput(false);
    setFormData({ ...formData, otp: "" });
  }, [formData]);

  const handleForm = useCallback(
    (e) => {
      e.preventDefault();
      setError({});
      if (!otpInput) {
        emailSchema
          .validate(
            { email: formData?.email },
            { strict: false, abortEarly: false }
          )
          .then((res) => handleLogin(res))
          .catch((err) => handleValidationError(err));
      } else if (otpInput) {
        otpSchema
          .validate(formData, { strict: false, abortEarly: false })
          .then((res) => handleVerifyOTP(res))
          .catch((err) => handleValidationError(err));
      }
    },
    [otpInput, formData, handleValidationError, handleVerifyOTP, handleLogin]
  );

  return (
    <div
      className="simple-bg-screen"
      style={{
        backgroundImage:
          'url("' + require("../Assets/img/banner-10.jpg") + '")',
      }}
    >
      <div className="Loader" />
      <div className="wrapper">
        {/* Title Header Start */}
        <section className="login-screen-sec">
          <div className="container">
            <div className="login-screen text-center">
              <Link to="/">
                <img
                  src={require("../Assets/img/PC-login-page.png")}
                  width={140}
                  alt=""
                />
              </Link>
              <br />
              <br />
              <form className="was-validated" onSubmit={handleForm}>
                <input
                  type="text"
                  className="form-control mb-1"
                  placeholder="Email"
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  readOnly={otpInput}
                />
                {errors?.email !== undefined && (
                  <div className="invalid-feedback d-block text-left">
                    {errors?.email}
                  </div>
                )}
                {otpInput && (
                  <Fragment>
                    <input
                      type="text"
                      className="form-control mb-1"
                      placeholder="OTP"
                      onChange={(e) =>
                        setFormData({ ...formData, otp: e.target.value })
                      }
                    />
                    {errors?.otp !== undefined && (
                      <div className="invalid-feedback d-block text-left">
                        {errors?.otp}
                      </div>
                    )}
                    <div className="d-flex justify-content-between">
                      <Link to={"#"} onClick={handleEmailChnage}>
                        Change Email?
                      </Link>
                      <Link to={"#"} onClick={handleLogin}>
                        Resend OTP
                      </Link>
                    </div>
                  </Fragment>
                )}
                <br />
                <button
                  className="btn btn-login"
                  //onClick={handleForm}
                  type="submit"
                  disabled={isLoading}
                >
                  {otpInput ? "Verify OTP" : state?.login ? "Login" : "Submit"}
                </button>
                <br />
              </form>
              {/* <span>
                You Have No Account?
                <Link to="/create-profile"> Create An Account</Link>
              </span> */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
